'use strict';

angular.module('shiftTraderApp')
    .controller('BuyTokenPlanDialogCtrl', function ($http, $scope, Registration, $modalInstance, params, Users,
                                                       $timeout, ServerUrls, flash, SAErrorHandler) {

      $http.get(ServerUrls.current.railsApi + 'token_ledgers/get_plans/')
        .then(function(response) {
          $scope.tokenPlans = response.data;
        });

      $scope.selectedPlan = null;
      $scope.applySelected = function(plan) {
        $scope.selectedPlan = plan;
      };

      $scope.close = function() {
          $modalInstance.close();
      };

      $scope.state = {
        processing: false
      };
      $scope.done = function() {
        if (!$scope.state.processing) {
          $scope.state.processing = true;

          var req = {
            method: 'POST',
            url: ServerUrls.current.railsApi + 'organizations/' + params.org.id + '/token_ledgers/buy_plan',
            data: {
              organization_id: params.org.id,
              plan_id: $scope.selectedPlan.id
            }
          }

          $http(req).then(function(res) {
            flash.success = "Success!"
            $modalInstance.close(res.data.balance);
          }, function(res) {
            SAErrorHandler.processError(res);
            $scope.state.processing = false;
          });
        }
      };
    });
